import { Tag, TagSize, type TagVariant } from '#app/components/Tags/Tag.js';

type RolesListProps = {
  readonly limit?: number;
  readonly readOnly?: boolean;
  readonly roles: ReadonlyArray<{ id: string; name: string }>;
  readonly size?: TagSize;
  readonly variant?: TagVariant;
};

export const RolesList = ({
  limit = undefined,
  readOnly = false,
  roles,
  size = 'default',
  variant = 'default',
}: RolesListProps) => {
  if (!roles.length) {
    return null;
  }

  const rolesList = limit ? roles.slice(0, limit) : roles;
  const delta = limit ? roles.length - rolesList.length : 0;
  const displayDelta = delta > 0;

  return (
    <>
      {rolesList.map(({ id, name }) => (
        <Tag
          key={id}
          label={name}
          readOnly={readOnly}
          size={size}
          variant={variant}
        />
      ))}
      {displayDelta ? (
        <Tag
          key="role-delta"
          label={`+${delta}`}
          readOnly={readOnly}
          variant={variant}
        />
      ) : null}
    </>
  );
};
